import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App'
import routers from './router'
import './public-path'
// 单独跑就把这个注释去掉，因为没有reset css样式会错乱
// import 'ant-design-vue/lib/style/core/index.less'
// less文件需单独 import， 故由 vue.config.js 中的 less-loader 配置统一添加
// import 'ant-design-vue/lib/style/themes/index.less'
import 'ant-design-vue/lib/style/components.less'
// 公共样式
import '@/assets/css/global.less'

Vue.config.productionTip = false
Vue.use(VueRouter)

let router = null
let instance = null

function loadTheme (prefix, theme) {
  // 开发环境不需要手动加载 css，直接更改 html class 即可
  // 构建后才会提取 css 文件
  if (process.env.NODE_ENV === 'production') {
    const _scopeName = `theme-${theme}`
    // eslint-disable-next-line no-undef
    const themeTimestampArr = __THEME_TIMESTAMP__
    const themeFileTimestamp = (themeTimestampArr.find(({ scopeName }) => _scopeName === scopeName) || {}).mtime
    const linkEl = document.createElement('link')
    linkEl.type = 'text/css'
    linkEl.rel = 'stylesheet'
    linkEl.href = prefix + `css/${_scopeName}-${themeFileTimestamp}.css`
    let tagName = 'qiankun-head'
    // 本地开发 || 非微前端环境
    if (theme === 'default' || !window.__MICRO_ROOT__) {
      tagName = 'head'
    }
    const parent = document.getElementsByTagName(tagName)[0]
    parent.insertBefore(linkEl, parent.getElementsByTagName('link')[0])
  }
}

function render (props = {}) {
  const { container } = props

  router = new VueRouter({
    mode: 'history',
    base: window.__POWERED_BY_QIANKUN__ ? '/micro/user/' : process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: routers
  })

  router.beforeEach((to, from, next) => {
    window.__MICRO_ROOT__?.eventBus?.emit('micro_app:loading', null, true)
    window.top.postMessage('MICROAPP::LOADING', '*')

    if (to.matched.length) {
      next()
    } else {
      if (location.pathname.startsWith('/micro/user/')) {
        next({ name: '404' })
      } else {
        next()
      }
    }
  })

  router.afterEach((to) => {
    if (to.matched.length) {
      window.__MICRO_ROOT__?.eventBus?.emit('micro_app:loading', null, false)
      window.top.postMessage('MICROAPP::LOADING::COMPLETE', '*')
    }
  })

  /* eslint-disable no-new */
  instance = new Vue({
    router,
    render: h => h(App)
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  const iframeAirline = window.top.__IFRAME_CONFIG__?.airline
  if (iframeAirline) {
    document.documentElement.className += ` theme-${iframeAirline}`
    loadTheme(process.env.BASE_URL, iframeAirline)
  } else {
    document.documentElement.className += ' theme-default'
    loadTheme(process.env.BASE_URL, 'default')
  }
  render()
}

export async function bootstrap () {
  console.log('user app bootstraped')
}
export async function mount (props) {
  console.log('user app mount')
  const airline = window.__MICRO_ROOT__?.airline || 'default'
  loadTheme(window.__INJECTED_PUBLIC_PATH_BY_QIANKUN__, airline)

  // 二次进入时，js已在内存，会直接匹配路由开始渲染；
  // 当css extra时，css要走网络资源再插入，这可能会比渲染慢，所以延迟让渲染等等
  // 当然最佳的方式还是使用css体验沙箱
  setTimeout(() => {
    render(props)
  }, 100)
}
export async function unmount () {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
  router = null
}
